export const frCommunications = {
    'toast.apiErrors.SINGLE_DEMAND_MISSING_AUDIENCE':
        "Aucune audience n'est définie pour cet élément il ne peut pas être publié",
    'toast.apiErrors.SINGLE_DEMAND_MISSING_END_DATE':
        "La date d'échéance n'est pas définie pour cet élément il ne peut pas être publié",
    'toast.apiErrors.MISSING_PRICE': 'Le prix doit être défini',
    'toast.apiErrors.MISSING_MINIMAL_COUNT':
        'Le nombre minimal de personnes ciblées doit être défini',

    'navbar.communications': 'Communications',

    'communications.title': 'Communications',

    'communications.digitalmarketings.title': 'Digital',
    'communications.partnerships.title': 'Partenariat',
    'communications.leaflets.title': 'Prospectus',

    // COMMS >> LIST

    'communications.list.table.filters.label.state': 'État :',
    'communications.list.table.state.drafts': 'Brouillon',
    'communications.list.table.state.published': 'Publié',
    'communications.list.table.state.unpublished': 'Annulé',
    'communications.list.table.state.finished': 'Terminé',

    'communications.list.table.filters.favoriteShops': 'Mes centres favoris',
    'communications.list.table.filters.apply': 'Appliquer',

    // DIGITAL MARKETINGS >> LIST

    'digitalMarketings.list.pageTitle': 'Communications digitales',
    'digitalMarketings.list.table.emptyLabel': 'Aucune communication digitale pour le moment',
    'digitalMarketings.type': 'Digital',
    'digitalMarketings.list.actions.create.button.label': 'Créer une communication digitale',

    // PARTNERSHIPS >> LIST

    'partnerships.list.pageTitle': 'Partenariats',
    'partnerships.list.table.emptyLabel': 'Aucun partenariat pour le moment',
    'partnerships.type': 'Partenariat',
    'partnerships.list.actions.create.button.label': 'Créer un partenariat',

    // LEAFLETS >> LIST

    'leaflets.list.pageTitle': 'Prospectus',
    'leaflets.list.table.emptyLabel': 'Aucun prospectus pour le moment',
    'leaflets.type': 'Prospectus',
    'leaflets.list.actions.create.button.label': 'Créer un prospectus',

    //  PERMISSIONS
    'digitalMarketings.permissions.tab.title': 'Communications Digitales',
    'partnerships.permissions.tab.title': 'Partenariats',
    'leaflets.permissions.tab.title': 'Prospectus',

    // DETAILS

    'communication.delete.dialog.validateLabel': 'Supprimer',
    'communication.delete.dialog.cancelLabel': 'Annuler',

    // DETAILS > DIGITAL

    'communication.digitalmarketings.create.pageTitle': 'Création communication digitale',

    'communication.digitalmarketings.details.pageTitle': 'Détails communication digitale',
    'communication.digitalmarketings.create.input.name':
        'Saisissez ici le nom de la communication digitale *',
    'communication.digitalmarketings.create.input.code':
        'Saisissez ici le code de la communication digitale',

    'digitalMarketings.details.input.before_promo_price.label': 'Prix avant promo (par personne)',
    'digitalMarketings.details.input.before_promo_price.hint': 'Prix en euros',

    'digitalMarketings.details.input.price.label': 'Prix (par personne)',
    'digitalMarketings.details.input.price.hint': 'Prix en euros',

    'digitalMarketings.details.input.minimal_count.label': 'Nombre minimal de personnes ciblées',
    'digitalMarketings.details.input.minimal_count.hint': 'Nombre de personnes',

    'communication.delete.digitalmarketings.dialog.title':
        'Suppression de la communication digital',
    'communication.delete.digitalmarketings.dialog.content':
        'Êtes-vous sûr de vouloir supprimer cette communication digitale ?',

    'communication.digitalmarketings.details.tabs.notifs.manualInfo':
        "Envoyer une notification de relance aux collaborateurs qui n'ont pas encore consulté la communication digitale",

    // DETAILS > PARTNERSHIPS

    'communication.partnerships.create.pageTitle': 'Création partenariat',

    'communication.partnerships.details.pageTitle': 'Détails partenariat',
    'communication.partnerships.create.input.name': 'Saisissez ici le nom du partenariat *',
    'communication.partnerships.create.input.code': 'Saisissez ici le code du partenariat',

    'partnerships.details.input.before_promo_price.label': 'Prix avant promo',
    'partnerships.details.input.before_promo_price.hint': 'Prix en euros',

    'partnerships.details.input.price.label': 'Prix',
    'partnerships.details.input.price.hint': 'Prix en euros',

    'communication.delete.partnerships.dialog.title': 'Suppression du partenariat',
    'communication.delete.partnerships.dialog.content':
        'Êtes-vous sûr de vouloir supprimer ce partenariat ?',

    'communication.partnerships.details.tabs.notifs.manualInfo':
        "Envoyer une notification de relance aux collaborateurs qui n'ont pas encore consulté le partenariat",

    // DETAILS > LEAFLETS

    'communication.leaflets.create.pageTitle': 'Création prospectus',

    'communication.leaflets.details.pageTitle': 'Détails prospectus',
    'communication.leaflets.create.input.name': 'Saisissez ici le nom du prospectus *',
    'communication.leaflets.create.input.code': 'Saisissez ici le code du prospectus',

    'leaflets.details.input.before_promo_price.label': 'Prix avant promo',
    'leaflets.details.input.before_promo_price.hint': 'Prix en euros',

    'leaflets.details.input.price.label': 'Prix',
    'leaflets.details.input.price.hint': 'Prix en euros',

    'leaflets.details.input.weight.label': 'Poids',
    'leaflets.details.input.weight.hint': 'Poids en grammes',

    'leaflets.details.input.page_count.label': 'Nombre de pages',
    'leaflets.details.input.page_count.hint': 'Nb de pages',

    'communication.delete.leaflets.dialog.title': 'Suppression du prospectus',
    'communication.delete.leaflets.dialog.content':
        'Êtes-vous sûr de vouloir supprimer ce propspectus ?',

    'communication.leaflets.details.tabs.notifs.manualInfo':
        "Envoyer une notification de relance aux collaborateurs qui n'ont pas encore consulté le prospectus",

    // DETAILS > REPLIES
    'communication.filters.participation.button.label': 'Réponse',

    'communication.filters.participation.filterLabelName': 'Réponse :',
    'communication.filters.participation.Answered': 'Participe',
    'communication.filters.participation.NotAnswered': 'Ne participe pas',
    'communication.filters.participation.format': 'Réponse : {value}',

    'communication.digitalmarketings.details.tabs.results.tableHeader.totalOrdered':
        'Total commandé',
    'communication.digitalmarketings.details.tabs.results.tableHeader.detail': 'Détail commande',
    'communication.partnerships.details.tabs.results.tableHeader.participation': 'Participation',

    'communication.digitalmarketings.details.tabs.results.tableRow.detail':
        'Visualiser la commande',
    'communication.partnerships.details.tabs.results.tableRow.participation.true': 'Participe',
    'communication.partnerships.details.tabs.results.tableRow.participation.false':
        'Ne participe pas',

    'communication.digitalmarketings.details.tabs.results.detailDialog.header.detail':
        'Détail produit',
    'communication.digitalmarketings.details.tabs.results.detailDialog.header.target': 'Cible',
    'communication.digitalmarketings.details.tabs.results.detailDialog.row.minimal_count':
        '{minimal_count} pers.',
};
